import Offers from 'components/Offers/components/Offers/ver2';
import OffersMobile from 'components/Offers/components/Offers/ver2/mobile';
import CollapsibleSideMenu from 'components/common/CollapsibleSideMenu';
import OuterBodyContent from 'components/common/CollapsibleSideMenu/OuterBodyContent';
import OuterFitHeight from 'components/common/CollapsibleSideMenu/OuterFitHeight';
import OuterPathContent from 'components/common/CollapsibleSideMenu/OuterPathContent';
import NavbarFooter from 'components/common/NavbarFooter/ver3';
import { useDetectDevice } from 'hooks/useDetectDevice';
import React from 'react';

const OffersPage = () => {
  const { isMobile, isTablet } = useDetectDevice();

  if (isMobile || isTablet) {
    return (
      <OuterBodyContent>
        <OffersMobile />
        <NavbarFooter />
      </OuterBodyContent>
    );
  }
  return (
    <CollapsibleSideMenu>
      <OuterBodyContent>
        <OuterPathContent>
          <OuterFitHeight>
            <Offers />
          </OuterFitHeight>
        </OuterPathContent>
      </OuterBodyContent>
    </CollapsibleSideMenu>
  );
};

export default OffersPage;
